import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'

import { getTrendingCollection } from '../../../services'
import { Product4 } from '../../../services/script'
import { addToCart, addToWishlist, addToCompare } from "../../../actions";
import ProductItem from './product-item';
import Credit from '../../../assets/images/credit.png'
import Gift from '../../../assets/images/gift.png'
import Inter from '../../../assets/images/inter.png'

class Collection extends Component {

    render() {
        const { items, symbol, addToCart, addToWishlist, addToCompare, title, subtitle } = this.props;
        return (
            <div>
                {/*Paragraph*/}
                <section className="section-b-space j-box pets-box ratio_square">
                    <div className="container">
                        <div className="title1 title5">
                            <h3 className="title-inner1">{title}</h3>
                            <hr role="tournament6" />
                        </div>
                        <div className="row">

                            <div className="col">

                                <div className="product-box" >
                                    <div className="img-wrapper" style={{ height: '150px' }}>

                                        <div className="front mt-3" style={{ textAlign: 'center' }}>
                                            <img src={Gift}
                                                className="img-fluid lazyload bg-img"
                                                alt="" />
                                        </div>
                                        {/* <div className="cart-info cart-wrap">
                                            <button title="Add to cart" onClick={() => this.onOpenCartModal()}>
                                                درخواست کارت مجازی
                                            </button>


                                        </div> */}
                                    </div>
                                    <div className="blog-details mb-3" style={{ textAlign: 'center' }}>
                                        <p style={{ textAlign: 'center' }}>صدور کارت اعتباری </p>
                                        <hr className="style1" />
                                        <h6>صدور انواع کارت بین المللی ارزی شامل مسترکارت , ویزا کارت , تراول کارت ,فیزیکی که برای انواع خرید اینترنتی و ... استفاده می شود.</h6>
                                    </div>
                                    <div className="collection-block mb-2">
                                        <div className="collection-content text-center">
                                            <a href="" className="btn btn-outline">درخواست کارت مجازی</a>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col">

                                <div className="product-box" >
                                    <div className="img-wrapper" style={{ height: '150px' }}>

                                        <div className="front mt-3" style={{ textAlign: 'center' }}>
                                            <img src={Credit}
                                                className="img-fluid lazyload bg-img"
                                                alt="" />
                                        </div>
                                        {/* <div className="cart-info cart-wrap">
                                            <button title="Add to cart" onClick={() => this.onOpenCartModal()}>
                                                درخواست کارت مجازی
                                            </button>


                                        </div> */}
                                    </div>
                                    <div className="blog-details mb-3" style={{ textAlign: 'center' }}>
                                        <p style={{ textAlign: 'center' }}>گیفت کارت مجازی</p>
                                        <hr className="style1" />
                                        <h6>ایزی کارت۷۲۴ ارائه دهنده انواع گیفت کارت مجازی با کمترین کارمزد به صورت آنلاین و تحویل آنی. برای ثبت درخواست خرید گیفت کارت مجازی کلیک کنید.</h6>
                                    </div>
                                    <div className="collection-block mb-2">
                                        <div className="collection-content text-center">
                                            <Link to={`${process.env.PUBLIC_URL}/products`} >

                                                <a href="" className="btn btn-outline">درخواست گیفت کارت</a>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col">

                                <div className="product-box" >
                                    <div className="img-wrapper" style={{ height: '150px' }}>

                                        <div className="front mt-3" style={{ textAlign: 'center' }}>
                                            <img src={Inter}
                                                className="img-fluid lazyload bg-img"
                                                alt="" />
                                        </div>
                                        {/* <div className="cart-info cart-wrap">
                                            <button title="Add to cart" onClick={() => this.onOpenCartModal()}>
                                                درخواست کارت مجازی
                                            </button>


                                        </div> */}
                                    </div>
                                    <div className="blog-details mb-3" style={{ textAlign: 'center' }}>
                                        <p style={{ textAlign: 'center' }}>پرداخت بین‌المللی</p>
                                        <hr className="style1" />
                                        <h6>خدمات پرداخت ارزی ایزی کارت۷۲۴ از طریق سیستم‌های مالی بین المللی نظیر پی پال، مستر کارت و ویزا کارت صورت می‌گیرد.</h6>
                                    </div>
                                    <div className="collection-block mb-2">
                                        <div className="collection-content text-center">
                                            <a href="" className="btn btn-outline">درخواست پرداخت</a>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    items: getTrendingCollection(state.data.products, ownProps.type),
    symbol: state.data.symbol
})

export default connect(mapStateToProps, { addToCart, addToWishlist, addToCompare })(Collection);